import React, { useState, useEffect } from "react";
import { Document } from "@react-pdf/renderer";
import PageLayout from "./page-layout";
import FirstPage from "./pages/FirstPage";
import SixthPage from "./pages/SixthPage";
import SecondPage from "./pages/SecondPage";
import ThirdPage from "./pages/ThirdPage";
import FourthPage from "./pages/FourthPage";
import FifthPage from "./pages/FifthPage";
import SeventhPage from "./pages/SeventhPage";
import EighthPage from "./pages/EighthPage";
import NinthPage from "./pages/NinthPage";

type Props = {
    freeText: string;
    events: { dateLocation: string; name: string; link: string }[];
    tableData: {
        date: string;
        dominantPollutant: string;
        NO2: number | string;
        O3: number | string;
        PM25: number | string;
        PM10: number | string;
    }[];
    alias: string;
    zNumber: number;
    selectedReportDate: string | undefined;
    onRenderComplete: Function;
    firstPageBarChart: string;
    dailyHeatmap: string;
    detailedHeatmap: string;
    fifthPageBarChart: string;
    hourlyHeatmap: string;
    firstPageBarChartText: string[];
    fourthPageDailyHeatmapText: string;
    fourthPageDetailedHeatmapText: JSX.Element;
    fifthPageBandName: string;
}

const PDFDocument: React.FC<Props> = React.memo(
    ({ freeText, events, tableData, alias, zNumber, selectedReportDate, onRenderComplete, firstPageBarChart, dailyHeatmap, detailedHeatmap, fifthPageBarChart, hourlyHeatmap, firstPageBarChartText, fourthPageDailyHeatmapText, fourthPageDetailedHeatmapText, fifthPageBandName }) => {

        const [isRendered, setIsRendered] = useState(false);

        useEffect(() => {
            if (isRendered) {
                onRenderComplete();
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [isRendered]);

        return (
            <Document onRender={() => setIsRendered(true)}>
                <PageLayout>
                    <FirstPage alias={alias} freeText={freeText} selectedReportDate={selectedReportDate} firstPageBarChart={firstPageBarChart} firstPageBarChartText={firstPageBarChartText} />
                </PageLayout>
                <PageLayout>
                    <SecondPage />
                </PageLayout>
                <PageLayout>
                    <ThirdPage events={events} />
                </PageLayout>
                <PageLayout>
                    <FourthPage dailyHeatmap={dailyHeatmap} detailedHeatmap={detailedHeatmap} fourthPageDailyHeatmapText={fourthPageDailyHeatmapText} fourthPageDetailedHeatmapText={fourthPageDetailedHeatmapText} />
                </PageLayout>
                <PageLayout>
                    <FifthPage fifthPageBarChart={fifthPageBarChart} hourlyHeatmap={hourlyHeatmap} fifthPageBandName={fifthPageBandName} />
                </PageLayout>
                <PageLayout>
                    <SixthPage tableData={tableData} />
                </PageLayout>
                <PageLayout>
                    <SeventhPage />
                </PageLayout>
                <PageLayout>
                    <EighthPage />
                </PageLayout>
                <PageLayout>
                    <NinthPage zNumber={zNumber} />
                </PageLayout>
            </Document>
        );
    }
);

export default PDFDocument;
